export default {
  allAuthorizedServices: [],
  authorizedService: {},
}
